import { IFeatureAppContent } from '../../../content/feature-service-types';
import { IChatWidgetState, ChatWidgetStatus, DeviceType } from './types';

export const getDefaultChatWidgetState = (cmsContent: IFeatureAppContent): IChatWidgetState => {
  return {
    status: ChatWidgetStatus.LOADING,
    isWindowOpen: false,
    error: null,
    position: cmsContent.chatWidget.floatingButtonsContainerPosition,
    floatingButtonsPosition: {
      closed: { bottom: '32px', [cmsContent.chatWidget.floatingButtonsContainerPosition]: '24px' },
      open: { bottom: '520px', [cmsContent.chatWidget.floatingButtonsContainerPosition]: '24px' }, // Default above the chat window (approx 480px height)
    },
    isLegalAccepted: false,
    deviceType: DeviceType.DESKTOP,
    isAgentsAvailable: true, // Assume available until proven otherwise
    areFloatingButtonsHidden: false,
  };
};
